module.exports = __webpack_public_path__ + "media/luxury-2026/black-dining-960-3d99519d.jpg";